import { v4 as uuidv4 } from "uuid";
import { displayError, displayWarning } from "../../utils/messageToast";
import { GroupProps, FieldProps } from "../../utils/functionsInterfaces";
import { getSkillId } from "../getSkill";
import { getTabId } from "../getTab";
import { formatNameAlias } from "../formatNameAlias";
import { SetupAuth } from "../../client";

export const getFormSideProps = async (
  setExpandedPages: React.Dispatch<React.SetStateAction<boolean>>,
  setShowTopPageContainer: React.Dispatch<React.SetStateAction<boolean>>,
  setNamePage: React.Dispatch<React.SetStateAction<string>>,
  setPageId: React.Dispatch<React.SetStateAction<string>>,
  setIsData: React.Dispatch<React.SetStateAction<boolean>>,
  search: string,
  setFormId: React.Dispatch<React.SetStateAction<string>>,
  setNameForm: React.Dispatch<React.SetStateAction<string>>,
  setSkillIdForm: React.Dispatch<React.SetStateAction<string>>,
  setTabIdForm: React.Dispatch<React.SetStateAction<string>>,
  setItemId: React.Dispatch<React.SetStateAction<string>>,
  setGroups: React.Dispatch<React.SetStateAction<GroupProps[]>>,
  setFields: React.Dispatch<React.SetStateAction<FieldProps[]>>,
  setShowTopContainer: React.Dispatch<React.SetStateAction<boolean>>,
  setButtonPublish: React.Dispatch<React.SetStateAction<boolean>>,
  clientId: string,
  setAliasFormResult: React.Dispatch<React.SetStateAction<string>>,
  setForm: React.Dispatch<React.SetStateAction<any[]>>,
  ambient: string,
  setSkillName: React.Dispatch<React.SetStateAction<string>>,
  authorization: string,
  setTabName: React.Dispatch<React.SetStateAction<string>>,
  isInForce?: boolean,
  onFormLoaded?: (payload: any) => void,
) => {
  try {
    if (search.trim() === "") {
      displayWarning("Digite um alias para buscar o formulário!");
      return;
    } else {
      if (!clientId) {
        displayWarning("Preencha o clientId!");
        return;
      }
      const apiClient = SetupAuth(authorization);
      const response = await apiClient.post(`/get-form`, {
        clientId,
        alias: search,
        ambient,
      });
      setFormId(response.data.id);
      setNameForm(response.data.name);
      await formatNameAlias(response.data.name, setAliasFormResult);
      setSkillIdForm(response.data.skillId);
      setTabIdForm(response.data.tabId);
      setItemId(response.data.itemId);
      let form;

      if (response.data.children[0].type === "page") {
        setIsData(true);
        setPageId(response.data.children[0].id);
        setNamePage(response.data.children[0].name);
        form = response.data.children[0].children;
      } else {
        setIsData(false);
        form = response.data.children;
      }

      getSkillId(
        response.data.skillId,
        authorization,
        ambient,
        setSkillName,
        isInForce
      );

      getTabId(
        response.data.tabId,
        authorization,
        ambient,
        setTabName,
        isInForce,
        response.data.skillId
      );

      // add uuid em cada objeto do form
      form = form.map((field: any) => {
        field.uuid = uuidv4();
        if (field.type === "group") {
          field.children = field.children.map((field: any) => {
            field.uuid = uuidv4();
            return field;
          });
        }
        return field;
      });
      setForm(form);
      if (onFormLoaded && response?.data) {
        const payload = {
          id: response.data.id,
          name: response.data.name,
          skillId: response.data.skillId,
          tabId: response.data.tabId,
          itemId: response.data.itemId,
          alias: response.data.alias,
          template: { children: form },
        };
        onFormLoaded(JSON.parse(JSON.stringify(payload)));
      }
      setShowTopContainer(true);
      setShowTopPageContainer(true);
      setButtonPublish(false);
      setExpandedPages(true);
    }
  } catch (error: any) {
    if (error.response.status === 404) {
      setShowTopContainer(false);
      setGroups([]);
      setFields([]);
      setForm([]);
      displayWarning("Formulário não encontrado!");
    } else if (error.response.status === 401) {
      setShowTopContainer(false);
      setGroups([]);
      setFields([]);
      setForm([]);
      displayWarning("Você não tem permissão para acessar este formulário!");
    } else {
      displayError("Erro ao buscar formulário!");
    }
  }
};
